<template>
  <div class="hyperion-login-card">
    <!-- Login Header -->
    <div class="login-header">
      <div class="welcome-icon">
        <a-icon type="safety-certificate" class="security-icon" />
      </div>
      <h1 class="login-title">Welcome Back</h1>
      <p class="login-subtitle">Sign in to your account</p>
    </div>

    <!-- Login Form -->
    <a-form
      id="formLogin"
      class="hyperion-login-form"
      ref="formLogin"
      :form="form"
      @submit="handleSubmit"
      layout="vertical">

      <!-- Username Field -->
      <a-form-item label="Username" class="form-item">
        <a-input
          size="large"
          type="text"
          placeholder="Enter your username"
          class="hyperion-input"
          v-decorator="[
            'username',
            {
              rules: [{
                required: true,
                message: 'Please enter your username'
              }]
            }
          ]">
          <a-icon slot="prefix" type="user" />
        </a-input>
      </a-form-item>

      <!-- Password Field -->
      <a-form-item label="Password" class="form-item">
        <a-input-password
          size="large"
          autocomplete="current-password"
          placeholder="Enter your password"
          class="hyperion-input"
          v-decorator="[
            'password',
            {
              rules: [{
                required: true,
                message: 'Please enter your password'
              }]
            }
          ]">
          <a-icon slot="prefix" type="lock" />
        </a-input-password>
      </a-form-item>

      <!-- Remember Me -->
      <a-form-item class="remember-item">
        <a-row type="flex" justify="space-between" align="middle">
          <a-col>
            <a-checkbox v-decorator="['remember']" class="remember-checkbox">
              Remember me
            </a-checkbox>
          </a-col>
        </a-row>
      </a-form-item>

      <!-- Submit Button -->
      <a-form-item class="submit-item">
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="hyperion-login-btn"
          :loading="loading"
          :disabled="loading"
          block>
          <a-icon type="login" v-if="!loading" />
          {{ loading ? 'Signing in...' : 'Sign In' }}
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
export default {
  name: 'HyperionLoginForm',
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, formData) => {
        if (!err) {
          this.loading = true
          this.$http.post(this.routeUri('auth.login.attempt'), formData)
            .then((response) => this.handleSuccessResponse(response.data))
            .catch((error) => this.handleErrorResponse(error.response.data.data))
        }
      })
    },
    handleSuccessResponse(data) {
      this.$notification.success({
        message: "Login Successful",
        description: "You will be redirected in a moment...",
        duration: 3
      })

      setTimeout(() => window.location.href = data.redirect, 2000)
    },
    handleErrorResponse(data) {
      this.loading = false

      this.form.setFields(_.mapValues(data, function (item, key) {
        return {
          errors: item.map(function (val) {
            return {
              field: key,
              message: val
            }
          })
        }
      }))
      this.form.setFields({password: {value: null}})

      this.$notification.error({
        message: "Login Failed",
        description: "Invalid username or password.",
        duration: 4
      })
    }
  }
}
</script>
